// removed by extract-text-webpack-plugin
module.exports = {"loader":"_2ZO_gSq2D _2tvY6e7Hw _17qxy1jyE","loader-center":"_295Frtfgz _34YKmqAjT qigzzAbil","dot":"_2o94ch6N1 ZmOqIoBS0 _2QmiN2YWU _1jY4uEptA _3lNMbxfs6 hwe2Hl53u","loader-animation":"_22ysC42fl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/loader/loader.css
 ** module id = 2140
 ** module chunks = 0
 **/